import React from 'react';
import { TranslationKey } from '../../../types/translation/TranslationKey';
import { t } from '../../../types/translation/Translator';
import { Icon } from '../../icons';
import { IconType } from '../../icons/Icon';

interface NoItemsFoundProps {
  title?: string;
  subtitle?: string;
  icon?: IconType;
}

export default function NoItemsFound({
  title = t(TranslationKey.noItemsFound).singular.upper,
  subtitle,
  icon = IconType.package,
}: NoItemsFoundProps) {
  return (
    <div className='flex flex-col items-center justify-center gap-4'>
      <div className='rounded-4 bg-primary-50 p-4'>
        <Icon type={icon} size={'size-16'} stroke='stroke-primary-600' strokeWidth='stroke-1' />
      </div>
      <div className='flex flex-col items-center justify-center gap-2 text-center'>
        <p className='text-lg font-semibold text-title'>{title}</p>
        {subtitle && <p className='w-[450px] text-sm text-subtitle'>{subtitle}</p>}
      </div>
    </div>
  );
}
